import OptimizerEditDto from "./OptimizerEditDto";

export class DifferentialEvolutionOptimizerEditDto extends OptimizerEditDto {
    constructor() {
        super();
        /** @type {number} */
        this.maxiter = null;
        /** @type {string} */
        this.strategy = null;
        /** @type {number} */
        this.popsize = null;
        /** @type {number} */
        this.mutation = null;
        /** @type {number} */
        this.recombination = null;
        /** @type {string} */
        this.updating = null;
        /** @type {string} */
        this.init = null;
    }

    /**
     * @typedef {Object} _DifferentialEvolutionOptimizerEditDtoProps
     * @property {number} maxiter
     * @property {string} strategy
     * @property {number} popsize
     * @property {number} mutation
     * @property {number} recombination
     * @property {string} updating
     * @property {string} init
     * 
     * @typedef {import('./OptimizerEditDto').OptimizerEditDtoProps & _DifferentialEvolutionOptimizerEditDtoProps} DifferentialEvolutionOptimizerEditDtoProps
     */
    /**
     * 
     * @param {DifferentialEvolutionOptimizerEditDtoProps} props
     * @returns {DifferentialEvolutionOptimizerEditDto}
     */
    setup(props) {
        super.setup(props);

        this.maxiter = props.maxiter;
        this.strategy = props.strategy;
        this.popsize = props.popsize;
        this.mutation = props.mutation;
        this.recombination = props.recombination;
        this.updating = props.updating;
        this.init = props.init;
        return this;
    }
}

export default DifferentialEvolutionOptimizerEditDto;
